<template>
<div class="form">
<a-card :title="c_title">
    <v-gobackbutton slot="extra" >返回</v-gobackbutton>
    <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item ref="jobname" label="定时任务名称" prop="jobname">
            <a-input
                v-model="record.jobname"
                :disabled="disabled"
                max-Length="25"
                    @blur="
                    () => {
                        $refs.jobname.onFieldBlur();
                    }
                    "
            />
        </a-form-model-item>
        <a-form-model-item ref="jobgroup" label="任务分组" prop="jobgroup">
            <a-input
                v-model="record.jobgroup"
                :disabled="disabled"
                    @blur="
                    () => {
                        $refs.jobgroup.onFieldBlur();
                    }
                    "
            />
        </a-form-model-item>
        <a-form-model-item ref="cronexpression" label="任务规则" prop="cronexpression">
            <a-input
                v-model="record.cronexpression"
                :disabled="disabled"
                    @blur="
                    () => {
                        $refs.cronexpression.onFieldBlur();
                    }
                    "
            />
        </a-form-model-item>
        <a-form-model-item ref="beanclass" label="执行任务类路径" prop="beanclass">
            <a-input
                v-model="record.beanclass"
                :disabled="disabled"
                    @blur="
                    () => {
                        $refs.beanclass.onFieldBlur();
                    }
                    "
            />
        </a-form-model-item>
        <a-form-model-item ref="springid" label="类名" prop="springid">
            <a-input
                v-model="record.springid"
                :disabled="disabled"
                    @blur="
                    () => {
                        $refs.springid.onFieldBlur();
                    }
                    "
            />
        </a-form-model-item>
        <a-form-model-item ref="methodname" label="方法名" prop="methodname">
            <a-input
                v-model="record.methodname"
                :disabled="disabled"
                    @blur="
                    () => {
                        $refs.methodname.onFieldBlur();
                    }
                    "
            />
        </a-form-model-item>

        <a-form-model-item ref="isconcurrent" label="是否等待执行" prop="isconcurrent" >
            <a-radio-group v-model="record.isconcurrent" button-style="solid" >
                <a-radio-button value="0">
                否
                </a-radio-button>
                <a-radio-button value="1">
                是
                </a-radio-button>
            </a-radio-group>
        </a-form-model-item>

        <a-form-model-item label="备注" prop="description">
            <a-input v-model="record.description" :disabled="disabled" type="textarea" />
        </a-form-model-item>

        <a-form-model-item :wrapper-col="{ span: 14, offset: 14 }" v-show="is_vue_task">
        <a-button type="primary" @click="handleOk">
            保存
        </a-button>
        <a-button style="margin-left: 10px;" @click="handleCancel">
            取消
        </a-button>
        </a-form-model-item>
    </a-form-model>


</a-card>
</div>
  
</template>
<script>
import { mapState } from "vuex";
const m_title = {
    'add':'新增定时任务',
    'detail':'查看定时任务',
    'edit':'编辑定时任务',
};
export default {
    data() {
        return {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
            rules: {
                jobname: [
                    { required: true, message: '请输入定时任务名称', trigger: 'blur' },
                ],
                jobgroup: [
                    { required: true, message: '请输入任务分组', trigger: 'blur' },
                ],
                cronexpression:[
                    { required: true, message: '请输入任务规则', trigger: 'blur' },
                ],
                beanclass:[
                    { required: true, message: '请输入执行任务类路径', trigger: 'blur' },
                ],
                springid:[
                    { required: true, message: '请输入类名', trigger: 'blur' },
                ],
                methodname:[
                    { required: true, message: '请输入方法名', trigger: 'blur'  },
                ],
                isconcurrent:[
                    { required: true, message: '请选择是否开启'},
                ],
            },
            confirmLoading: false,
            formItemLayout:'horizontal',
            c_title:'',
            is_vue_task : true,
            disabled: this.$route.params.action == "detail" ? true : false 
        };
    },

    methods: {
        handleOk() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    this.record.isconcurrent =  this.record.isconcurrent;
                    console.log("record===>"+this.record.isconcurrent);
                    const { params } = this.$route;
                    if(params.action == 'edit'){
                        //编辑
                        this.record.id = this.record.id;
                        this.$store
                            .dispatch({
                                type: "timetask/updateTask",
                                params: this.record
                            })
                            .then((response) => {
                                console.log(response)
                                this.handleCancel();
                                this.confirmLoading = false;
                            });
                    }
                    else if(params.action == 'add'){
                        //新增
                        this.$store
                            .dispatch({
                                type: "timetask/addTask",
                                params: this.record
                            })
                            .then((response) => {
                                console.log(response)
                                if(response.data.success == '1'){
                                    this.handleCancel();
                                }
                                this.confirmLoading = false;
                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
            
        },

        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
    },
    computed: {
        ...mapState("timetask", {
            record: function(state) {
                return this.action == "add" ? {} : state.record;
            }
        })
        
    },
    mounted(){
        const { query, params } = this.$route;
        this.c_title = m_title[params.action]
        if (params.action != "add") {
            this.$store.dispatch({
                type: "timetask/detailTask",
                params: query,
                showMsg: false
            })
        }else{
            this.$store.dispatch({
                type: "timetask/getEmptyTask",
                params: query,
                showMsg: false
            })
        }
        this.is_vue_task = params.action != 'detail'
        
    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
.ant-input[disabled]{
    color: rgba(0, 0, 0, 0.55);
}
</style>
